<app-shared-header
  [headerData]="headerData"
  [loading]="loading"
></app-shared-header>
<div fxLayout="column" class="cards-container">
  <app-image-carousel [productId]="setId"> </app-image-carousel>

  <app-texts [productId]="setId"> </app-texts>

  <app-usage-examples [productId]="setId"></app-usage-examples>

  <app-legend-texts [productId]="setId"></app-legend-texts>

  <app-relations [productId]="setId"></app-relations>

  <app-attribute-table [productId]="setId"> </app-attribute-table>
</div>
